import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
// eslint-disable-next-line no-extend-native
Date.prototype.Format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1,
    // 月份
    'd+': this.getDate(),
    // 日
    'h+': this.getHours(),
    // 小时
    'm+': this.getMinutes(),
    // 分
    's+': this.getSeconds(),
    // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3),
    // 季度
    'S': this.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
};
export function formatTimeToStr(times, pattern) {
  var d = new Date(times).Format('yyyy-MM-dd hh:mm:ss');
  if (pattern) {
    d = new Date(times).Format(pattern);
  }
  return d.toLocaleString();
}
export function timeStamp(times) {
  return new Date(times).getTime() / 1000;
}
export function indi(str) {
  if (str == '') return '';
  var arr = str.replace(" ", ":").replace(/\:/g, "-").split("-");
  var hour = parseInt(arr[3]);
  var minutes = parseInt(arr[4]);
  if (minutes >= 30) {
    return indiHour(arr, hour, 2) + ":" + (minutes - 30 >= 10 ? (minutes - 30).toString() : '0' + (minutes - 30)) + ':' + arr[5];
  } else {
    return indiHour(arr, hour, 3) + ":" + (60 + minutes - 30 >= 10 ? (60 + minutes - 30).toString() : '0' + (60 + minutes - 30)) + ':' + arr[5];
  }
}
function indiHour(arr, hour, num) {
  if (hour >= num) {
    return arr[0] + '-' + arr[1] + '-' + arr[2] + ' ' + (hour - num >= 10 ? (hour - num).toString() : '0' + (hour - num));
  } else {
    var ri = parseInt(arr[2]);
    return indiRi(arr, ri) + " " + (24 + hour - num >= 10 ? (24 + hour - num).toString() : 60 + hour - num);
  }
}
function indiRi(arr, ri) {
  if (ri > 1) {
    return arr[0] + '-' + arr[1] + '-' + (ri - 1 >= 10 ? (ri - 1).toString() : '0' + (ri - 1));
  } else {
    var month = parseInt(arr[1]);
    if ([2, 5, 7, 8, 10].indexOf(month) < 0) {
      return indiMonth(arr, month) + '-' + (30 + ri - 1 >= 10 ? (30 + ri - 1).toString() : '0' + (30 + ri - 1));
    } else if (month == 3) {
      if (parseInt(arr[0]) / 4 == 0) {
        return indiMonth(arr, month) + '-' + (29 + ri - 1 >= 10 ? (29 + ri - 1).toString() : '0' + (29 + ri - 1));
      } else {
        return indiMonth(arr, month) + '-' + (28 + ri - 1 >= 10 ? (28 + ri - 1).toString() : '0' + (28 + ri - 1));
      }
    } else {
      return indiMonth(arr, month) + '-' + (31 + ri - 1 >= 10 ? (31 + ri - 1).toString() : '0' + (31 + ri - 1));
    }
  }
}
function indiMonth(arr, month) {
  if (month > 1) {
    return arr[0] + '-' + (month - 1 >= 10 ? (month - 1).toString() : '0' + (month - 1));
  } else {
    var year = parseInt(arr[0]);
    return (year - 1).toString() + "-12";
  }
}
export function GetDateStr(AddDayCount) {
  var dd = new Date();
  dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
  var y = dd.getFullYear();
  var m = dd.getMonth() + 1; //获取当前月份的日期
  var d = dd.getDate();
  return y + "-" + (m >= 10 ? m : "0" + m) + "-" + (d >= 10 ? d : "0" + d);
}